module.exports = __webpack_public_path__ + "img/edge_patrimoine_archeologie.e1971df4.svg";